import React, { useCallback, useState, useEffect } from 'react'
import { Form, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import GreenCheckMark from '../../../../resources/GreenCheckMark.png'
import RedCrossMark from '../../../../resources/RedCrossMark.png'
import $t from '../../../../i18n'
import {
  FormFields,
  passwordRules as passwordRulesList,
  passwordRuleTitleConsts,
} from '../../../../consts'
import Page from '../../../common/Page'
import MaterialInput from '../../../common/MaterialInput'
import PageCard from '../../../common/PageCard'

import '../ChoosePassword/ChoosePassword.css'

const ChooseNewPassword = () => {
  const [form] = Form.useForm()
  const { getFieldValue, getFieldError } = form

  const dispatch = useDispatch()
  // const state = useSelector(state => state)
  const { resetPassword } = useSelector(state => state.auth)
  // const isAuthenticated = useSelector(state => state.auth.isLoggedIn)
  const [passwordRules, setPasswordRules] = useState(passwordRulesList)
  const [shouldStartDynamicValidation, setShouldStartDynamicValidation] =
    useState(false)
  const [isValidPassword, setIsValidPassword] = useState(false)
  const [isValidReEnterPassword, setIsValidReEnterPassword] = useState(false)

  const { token, isPasswordResetLoading, passwordResetErrorMessage } =
    resetPassword

  useEffect(() => {
    const updatedRules = [...passwordRules]
    if (
      passwordResetErrorMessage &&
      typeof passwordResetErrorMessage !== 'string'
    ) {
      passwordResetErrorMessage.forEach(message => {
        if (!updatedRules.find(eachRule => eachRule.text === message)) {
          updatedRules.push({
            isValid: false,
            text: message,
            title: passwordRuleTitleConsts.BE_ERROR,
          })
        }
      })
    } else if (
      passwordResetErrorMessage &&
      typeof passwordResetErrorMessage === 'string'
    ) {
      if (
        !updatedRules.find(
          eachRule => eachRule.text === passwordResetErrorMessage
        )
      ) {
        updatedRules.push({
          isValid: false,
          text: passwordResetErrorMessage,
          title: passwordRuleTitleConsts.BE_ERROR,
        })
      }
    }
    setPasswordRules([...updatedRules])
  }, [passwordResetErrorMessage])

  const renderPasswordRules = () => {
    return (
      <div className="password-rules-container">
        <div className="password-rules-title">
          {$t('pages.getStarted.signupForm.passwordRules.passwordMustInclude')}
        </div>
        {passwordRules.map((rule, i) => {
          return (
            <div className="rule-continer" key={i}>
              {shouldStartDynamicValidation ? (
                <img
                  className="validation-rule-icon"
                  alt=""
                  src={rule.isValid ? GreenCheckMark : RedCrossMark}
                />
              ) : null}
              <span
                className={
                  shouldStartDynamicValidation
                    ? rule.isValid
                      ? 'valid-rule-text'
                      : 'invalid-rule-text'
                    : 'rule-text'
                }
              >
                {rule.text}
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  const handleSignup = useCallback(data => {
    dispatch(
      Actions.createAction(Actions.RESET_PASSWORD_REQUESTED, {
        password: data.password,
        token,
        // route: isAuthenticated ? routes.PROFILE_ROUTE.PROFILE : routes.SIGN_IN,
        // state,
      })
    )
  }, [])

  const validateReEnterPassword = (rule, value, callback) => {
    const password = getFieldValue(FormFields.password)

    if (value !== password) {
      setIsValidReEnterPassword(false)
      callback($t('pages.getStarted.signupForm.errors.passwordDontMatch'))
    } else {
      setIsValidReEnterPassword(true)
      callback()
    }
  }

  const validatePassword = (rule, value, callback) => {
    const rules = [...passwordRules]
    const numberFormat = /\d/
    const lowerCaseAlphabetFormat = /[a-z]/
    const upperCaseAlphabetFormat = /[A-Z]/
    const specialCharacterFormat = /[~!@#$%^&*_+=`|\\(){}[\]:;'<>,.?/-]/
    const inValidRuleTitles = []

    if (!shouldStartDynamicValidation) {
      setShouldStartDynamicValidation(true)
    }

    if (!numberFormat.test(value)) {
      inValidRuleTitles.push(passwordRuleTitleConsts.NUMBER)
    }
    if (!lowerCaseAlphabetFormat.test(value)) {
      inValidRuleTitles.push(passwordRuleTitleConsts.SMALL_LETTER)
    }
    if (!upperCaseAlphabetFormat.test(value)) {
      inValidRuleTitles.push(passwordRuleTitleConsts.CAPITAL_LETTER)
    }
    if (!specialCharacterFormat.test(value)) {
      inValidRuleTitles.push(passwordRuleTitleConsts.SPECIAL_CHARACTER)
    }
    if (value.length <= 7) {
      inValidRuleTitles.push(passwordRuleTitleConsts.LENGTH)
    }
    if (value === '') {
      callback($t('pages.getStarted.signupForm.errors.pleaseInputYourPassword'))
    } else {
      callback()
    }

    const updatedPasswordRules = rules.reduce((updatedRules, rule) => {
      if (inValidRuleTitles.includes(rule.title)) {
        updatedRules.push({ ...rule, isValid: false })
      } else if (rule.title === passwordRuleTitleConsts.BE_ERROR) {
        updatedRules.push({ ...rule, isValid: false })
      } else {
        updatedRules.push({ ...rule, isValid: true })
      }
      return updatedRules
    }, [])

    if (inValidRuleTitles.length === 0 && !isValidPassword) {
      setIsValidPassword(true)
    } else if (inValidRuleTitles.length && isValidPassword) {
      setIsValidPassword(false)
    }
    setPasswordRules([...updatedPasswordRules])
  }

  const shouldEnableNextButton = () => isValidPassword && isValidReEnterPassword

  return (
    <PageCard className="login-page-card change-password-page-card">
      <Page
        title={$t('pages.getStarted.signupForm.chooseAPassword')}
        className="login-page choose-password-page"
      >
        <Form
          className="password-form"
          onFinish={handleSignup}
          name="basic"
          initialValues={{
            password: '',
            reEnterPassword: '',
          }}
          form={form}
        >
          <Form.Item
            name={FormFields.password}
            type="text"
            rules={[{ validator: validatePassword }]}
          >
            <MaterialInput
              type="password"
              label={$t('pages.getStarted.signupForm.password')}
            />
          </Form.Item>
          <Form.Item
            name={FormFields.reEnterPassword}
            type="text"
            rules={[{ validator: validateReEnterPassword }]}
          >
            <MaterialInput
              type="password"
              label={$t('pages.getStarted.signupForm.reEnterPassword')}
            />
          </Form.Item>
          {renderPasswordRules()}
          <Form.Item className="rp-form-item-continue-button">
            <Button
              loading={isPasswordResetLoading}
              className="rp-signup-next-button"
              htmlType="submit"
              type="primary"
              disabled={!shouldEnableNextButton()}
            >
              {$t('pages.getStarted.signupForm.continue')}
            </Button>
          </Form.Item>
        </Form>
      </Page>
    </PageCard>
  )
}

export default ChooseNewPassword
